import React, {useEffect,useState, useMemo} from "react";
import {formatMoney, formatIntlMoney, stripHtml} from "../../../../../_utils";
import Image from "./Image";

export default function GiftCardImage({
  settings,
  giftCard,
  moneyFormat,
  preview,
}) {

  const [codeCopied, setCodeCopied] = useState(false);

  let codeParts = ["", "", "", ""];

  // Split into bits of 4
  if (typeof(giftCard.issued_gift_card_code) == "string" ) {
    codeParts = giftCard.issued_gift_card_code.match(new RegExp('.{1,4}', 'g'));
  }

  const expiryDate = (() => {
    // Create a Date object
    const date = new Date(giftCard.expiry_date);

    // Get month and year
    const month = date.getMonth() + 1; // Note: Months are zero-based, so we add 1
    const year = date.getFullYear();

    // Format the date as "mm/yyyy"
    return `${month.toString().padStart(2, '0')}/${year}`;
  })();

  useEffect(() => {
    if (codeCopied === true) {
      setTimeout(() => setCodeCopied(false), 5000);
    }
  }, [codeCopied]);

  /**
   * Copies the issued gift card code to the users clipboard
   * @param { string } text - The issued code to copy to the clipboard
   */
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCodeCopied(true);
  };

  const formattedAmount = useMemo(() => {

    try {

      const inDashboard = typeof window?.Shopify === "undefined";
      const isPresentmentCurrency = giftCard.presentment_cents && giftCard.presentment_currency !== giftCard.currency;

      const getAmount = (isPresentmentCurrency) => {
        let amount = null;
        if (preview) {
          amount = stripHtml(giftCard.amount);
        } else {
          amount = (isPresentmentCurrency) ? giftCard.presentment_cents : giftCard.amount_cents;
        }
        return !isNaN(parseInt(amount)) ? parseInt(amount) / 100 : 0;
      };

      const getCurrency = (inDashboard, isPresentmentCurrency) => {
        let currency = null;
        if (preview) {
          currency = (inDashboard) ? settings?.shop?.currency : window?.Shopify?.currency?.active;
        } else {
          currency = (isPresentmentCurrency) ? giftCard?.presentment_currency : giftCard?.currency;
        }
        return currency || "USD";
      };

      const getLocale = () => {
        let locale = (inDashboard) ? settings.locale : window?.Shopify?.locale;
        return locale || "en";
      };

      return formatIntlMoney(
        getAmount(isPresentmentCurrency),
        getCurrency(inDashboard, isPresentmentCurrency),
        getLocale(inDashboard, isPresentmentCurrency),
        moneyFormat || "{{amount}}",
      );
    
    } catch (error) {
      console.warn("Error formatting money", error);
      return "";
    }

  }, [giftCard?.amount, settings, moneyFormat, preview]);

  return (
    <>
      {codeCopied === true && <div className="gc__copy_notification">Code Copied</div> }
      <div className="gc__giftcard_wrapper" id="gc__id-printable">
        <div className="gc__gift-card">
          <div className="gc__gift_card_front">
            <div className="gc__strip-bottom"></div>
            <div className="gc__strip-top"></div>
            <div className="gc__gift_card_logo">
            {settings.shop.name}
            </div>

            <div className="gc__gift_card_amount">{formattedAmount}</div>
            <div className="gc__gift_card_number">
            {codeParts.map((part, index) => (
              <div
                key={`part${part}${index}`}
                className="gc_gift_card_section"
                onMouseDown={() => copyToClipboard(giftCard.issued_gift_card_code)}
                onTouchEnd={() => copyToClipboard(giftCard.issued_gift_card_code)}
              >{part}</div>
            ))}
            </div>
            <div className="gc__gift_card_end">
            {settings.digital.appearance.show_expiry_date === "1" && giftCard.expiry_date !== null && (
              <>
              <span className="gc__gift_card_end_text">exp.</span><span className="gc__gift_card_date">{expiryDate}</span>
              </>
            )}
            </div>
            <div className="gc__gift_card_holder">{giftCard.recipient_name}</div>
          </div>
        </div>
      </div>
    </>
  );
};
